import { ConnectWallet } from "@3rdweb/react";

const Layout = () => {
  return <ConnectWallet />;
};
export default Layout;